import { integrationIdFormat } from "@redotech/redo-integration-id";
import { HTTP_AUTH_SCHEMES } from "@redotech/redo-integrations-configs/connections/http.connection-type";
import { ConnectionKind } from "@redotech/redo-integrations-core/connection-type/connection-kind";
import * as z from "zod";

const connectionViewFields = {
  id: integrationIdFormat.schema,
  name: z.string(),
  /** Secrets are write-only; this only says whether one is stored. */
  secretSet: z.boolean(),
  createdBy: z.string().nullable(),
  updatedBy: z.string().nullable(),
  lastUsedAt: z.date().nullable(),
  lastError: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
};

const HttpConnectionView = z.object({
  ...connectionViewFields,
  type: z.literal(ConnectionKind.Http),
  metadata: z.object({
    baseUrl: z.string(),
    authScheme: z.enum(HTTP_AUTH_SCHEMES),
    headerName: z.string().nullable(),
    username: z.string().nullable(),
  }),
});

const ConnectionView_ = z.discriminatedUnion("type", [HttpConnectionView]);
export const ConnectionView: z.ZodType<ConnectionView> = ConnectionView_;
export type ConnectionView = z.infer<typeof ConnectionView_>;
